export default "__VITE_ASSET__CYdpZmUT__"